import {
	ORDERS_TABLE_PAGE_SIZE,
	ORDERS_TYPES,
} from "../../constants/OrdersPage";

import type { OrderPageState } from "./interface";

type StateWithOrdersPage = {
	ordersPageReducer: OrderPageState;
};

export const selectOrdersPageCompanies = (state: StateWithOrdersPage) =>
	state.ordersPageReducer.companies;

export const selectOrdersType = (state: StateWithOrdersPage) =>
	state.ordersPageReducer.ordersType;

export const selectOrdersTabCounts = (state: StateWithOrdersPage) => {
	const { orders } = state.ordersPageReducer;

	const countOf = (tab: keyof typeof orders) =>
		orders[tab]?.pagination?.count ?? orders[tab]?.count ?? 0;

	const live = countOf(ORDERS_TYPES.LIVE);
	const preliminary = countOf(ORDERS_TYPES.PRELIMINARY);
	const executable = countOf(ORDERS_TYPES.EXECUTABLE);

	return {
		[ORDERS_TYPES.LIVE]: live,
		[ORDERS_TYPES.PRELIMINARY]: preliminary,
		[ORDERS_TYPES.EXECUTABLE]: executable,
		// Open tabs partition filled orders; "All" is their sum, not a
		// separate subscribe counter that can drift after batched hydrate.
		[ORDERS_TYPES.ALL]: live + preliminary + executable,
		[ORDERS_TYPES.CLOSED]: countOf(ORDERS_TYPES.CLOSED),
	};
};

export const selectOrdersTabLimits = (state: StateWithOrdersPage) => {
	const { filters } = state.ordersPageReducer;
	const limitOf = (tab: keyof typeof filters) =>
		filters[tab]?.limit || ORDERS_TABLE_PAGE_SIZE;

	return {
		[ORDERS_TYPES.LIVE]: limitOf(ORDERS_TYPES.LIVE),
		[ORDERS_TYPES.PRELIMINARY]: limitOf(ORDERS_TYPES.PRELIMINARY),
		[ORDERS_TYPES.EXECUTABLE]: limitOf(ORDERS_TYPES.EXECUTABLE),
		[ORDERS_TYPES.ALL]: limitOf(ORDERS_TYPES.ALL),
		[ORDERS_TYPES.CLOSED]: limitOf(ORDERS_TYPES.CLOSED),
	};
};

export const selectActiveOrderId = (state: StateWithOrdersPage) =>
	state.ordersPageReducer.activeOrder?.id ?? null;

export const selectCurrentTabOrders = (state: StateWithOrdersPage) =>
	state.ordersPageReducer.orders[state.ordersPageReducer.ordersType];
